import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { api, describeAxiosError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { KPIS, monthLabel } from "./helpers";

export const MonthlyTargetModal = ({ employees, month, onClose, onSaved }) => {
  const [form, setForm] = useState({ employee_id: employees[0]?.id || "", month,
    sales_target: 500000, sales_achieved: 0, collection_target: 400000, collection_achieved: 0,
    scheme_target: 100000, scheme_achieved: 0 });
  const [busy, setBusy] = useState(false), [error, setError] = useState("");
  const submit = async (event) => {
    event.preventDefault(); if (busy) return;
    setBusy(true); setError("");
    try {
      const body = { ...form };
      for (const kpi of KPIS) {
        body[`${kpi}_target`] = Number(form[`${kpi}_target`]);
        body[`${kpi}_achieved`] = Number(form[`${kpi}_achieved`]);
      }
      await api.post("/performance", body);
      onSaved();
    } catch (e) { setError(describeAxiosError(e)); }
    finally { setBusy(false); }
  };
  return <Dialog open onOpenChange={(open) => { if (!open && !busy) onClose(); }}>
    <DialogContent className="bg-white w-[calc(100%-2rem)] max-w-xl max-h-[calc(100dvh-2rem)] overflow-y-auto rounded-lg" data-testid="perf-modal" closeTestId="monthly-target-close">
      <DialogHeader className="text-left pr-5"><DialogTitle data-testid="monthly-target-title">Record monthly targets</DialogTitle><DialogDescription data-testid="monthly-target-period">{monthLabel(month)}</DialogDescription></DialogHeader>
      <form onSubmit={submit} className="space-y-4" data-testid="monthly-target-form">
        <fieldset disabled={busy} className="space-y-4" data-testid="monthly-target-fields">
          <label className="block text-xs font-medium">Employee
            <select required className="w-full min-w-0 border rounded-md p-2 text-sm bg-white mt-2" value={form.employee_id} onChange={(e) => setForm({ ...form, employee_id: e.target.value })} data-testid="monthly-target-employee">
              <option value="" disabled>Select employee</option>{employees.map((e) => <option key={e.id} value={e.id}>{`${e.full_name} · ${e.designation || ""}`}</option>)}
            </select>
          </label>
          {KPIS.map((k) => <div key={k} className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {["target", "achieved"].map((kind) => <label key={kind} className="text-xs font-medium capitalize min-w-0">{k} {kind} ₹<Input type="number" required min="0" step="1" className="mt-2" value={form[`${k}_${kind}`]} onChange={(e) => setForm({ ...form, [`${k}_${kind}`]: e.target.value })} data-testid={`monthly-${k}-${kind}`} /></label>)}
          </div>)}
        </fieldset>
        {error && <p role="alert" className="text-sm text-red-700" data-testid="monthly-target-error">{error}</p>}
        <Button type="submit" className="w-full" disabled={busy || !form.employee_id} data-testid="save-performance-button">{busy ? <Loader2 className="animate-spin" /> : <Save />}Save</Button>
      </form>
    </DialogContent>
  </Dialog>;
};